var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 flex tracking-wide justify-center select-none text-center hover:opacity-75 m-auto rounded bg-empire-red text-xl cursor-pointer text-white w-1/3 md:w-1/6 lg:w-1/6 lg:w-1/12 xl:w-1/12 mt-6",on:{"click":function($event){return _vm.activateButton()}}},[_vm._v("\n  Random\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }